import React, {Component, ReactNode} from 'react';

interface Props {
    children: ReactNode;
}

interface State {
    hasChunkError: boolean;
}

export default class ChunkErrorBoundary extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {hasChunkError: false};
    }

    static getDerivedStateFromError(error: Error): State | null {
        if (error.name === 'ChunkLoadError') {
            return {hasChunkError: true};
        }
        return null;
    }

    componentDidCatch(error: Error) {
        if (error.name === 'ChunkLoadError') {
            const reloadKey = 'chunk_error_reload';
            if (!sessionStorage.getItem(reloadKey)) {
                sessionStorage.setItem(reloadKey, '1');
                window.location.reload();
            }
        }
    }

    render() {
        if (this.state.hasChunkError) {
            return (
                <div className='min-vh-100 d-flex align-items-center justify-content-center bg-dark text-white'>
                    <div className='text-center p-6'>
                        <h2 className='mb-4'>Strona została zaktualizowana</h2>
                        <p className='mb-6 text-secondary-light'>
                            Dostępna jest nowa wersja strony. Odśwież, aby kontynuować.
                        </p>
                        <button
                            className='btn btn-lg btn-success text-success-light shadow'
                            onClick={() => {
                                sessionStorage.removeItem('chunk_error_reload');
                                window.location.reload();
                            }}
                        >
                            Odśwież stronę
                        </button>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}
